import { Component } from '@angular/core';
import { CommonService } from 'src/app/services/common/common.service';
import { IndividualService } from 'src/app/services/individual/individual.service';

@Component({
  selector: 'app-exam-result',
  templateUrl: './exam-result.component.html',
  styleUrls: ['./exam-result.component.scss']
})
export class ExamResultComponent {
public isSpinnerLoading:boolean=false;
public isResultShow :boolean=false;
public resultData:any;
public paramsData:any;
constructor(private individualService:IndividualService,private commonService:CommonService){}
onSubmitOverallExam(newArray) {
  let data = {
    course_id: parseInt(this.paramsData.course_id),
    exam_id: parseInt(this.paramsData.exam_id),
    purchase_id: parseInt(this.paramsData.purchase_id),
    answers: newArray,
    t: this.paramsData.c_t
  }
  this.isSpinnerLoading = true;
  this.individualService.result(data).subscribe({
    next: (success: any) => {
      this.isSpinnerLoading = false;
      if (success.status == 200) {
        this.isResultShow = true;
        this.resultData = success["data"]
      }
    },
    error: (error: any) => {
      this.commonService.handleError(error)
    }
  })
}
onExamList(){}
}
